import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-777ee209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }

import { withDefaults, CSSProperties, computed } from 'vue'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'cell-wrap',
  props: {
    fillColor: { default: '#00C378' },
    showArrow: { type: Boolean, default: true },
    label: { default: '' },
    required: { type: Boolean, default: false },
    mainLinePb: { default: undefined },
    labelStyle: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { fillColor: string, showArrow: boolean, label: string, required: boolean, mainLinePb: number, labelStyle: CSSProperties };


const getMainLineStyle = computed(() => {
  console.log('props', props)
  const result: CSSProperties = {}
  if (props.mainLinePb !== undefined) {
    result.paddingBottom = `${props.mainLinePb}px`
  }
  return result
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "main-line",
      style: _normalizeStyle(_unref(getMainLineStyle))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["label xag-ellipsis", props.required ? 'red-star' : '']),
        style: _normalizeStyle(__props.labelStyle)
      }, _toDisplayString(__props.label), 7),
      _createVNode(IconArrowRightWrap, {
        fillColor: props.fillColor,
        showArrow: props.showArrow,
        class: "value"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "cell-right")
        ]),
        _: 3
      }, 8, ["fillColor", "showArrow"])
    ], 4),
    _renderSlot(_ctx.$slots, "block")
  ]))
}
}

})